/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { BriefType } from './';
import {
    BriefTypeFromJSON,
    BriefTypeFromJSONTyped,
    BriefTypeToJSON,
} from './';
import type { Criterion } from './';
import {
    CriterionFromJSON,
    CriterionFromJSONTyped,
    CriterionToJSON,
} from './';
import type { Duration } from './';
import {
    DurationFromJSON,
    DurationFromJSONTyped,
    DurationToJSON,
} from './';
import type { Finance } from './';
import {
    FinanceFromJSON,
    FinanceFromJSONTyped,
    FinanceToJSON,
} from './';
import type { Profile } from './';
import {
    ProfileFromJSON,
    ProfileFromJSONTyped,
    ProfileToJSON,
} from './';
import type { ProjectDescription } from './';
import {
    ProjectDescriptionFromJSON,
    ProjectDescriptionFromJSONTyped,
    ProjectDescriptionToJSON,
} from './';
import type { ProjectTitle } from './';
import {
    ProjectTitleFromJSON,
    ProjectTitleFromJSONTyped,
    ProjectTitleToJSON,
} from './';
import type { StartDate } from './';
import {
    StartDateFromJSON,
    StartDateFromJSONTyped,
    StartDateToJSON,
} from './';
import type { WorkConditions } from './';
import {
    WorkConditionsFromJSON,
    WorkConditionsFromJSONTyped,
    WorkConditionsToJSON,
} from './';

/**
 * 
 * @export
 * @interface UpdateBriefRequest
 */
export interface UpdateBriefRequest {
    /**
     * 
     * @type {ProjectTitle}
     * @memberof UpdateBriefRequest
     */
    title: ProjectTitle;
    /**
     * 
     * @type {ProjectDescription}
     * @memberof UpdateBriefRequest
     */
    description: ProjectDescription;
    /**
     * 
     * @type {Duration}
     * @memberof UpdateBriefRequest
     */
    duration: Duration;
    /**
     * 
     * @type {Finance}
     * @memberof UpdateBriefRequest
     */
    finance: Finance;
    /**
     * 
     * @type {WorkConditions}
     * @memberof UpdateBriefRequest
     */
    workConditions: WorkConditions;
    /**
     * 
     * @type {StartDate}
     * @memberof UpdateBriefRequest
     */
    startDate: StartDate;
    /**
     * 
     * @type {Profile}
     * @memberof UpdateBriefRequest
     */
    profile: Profile;
    /**
     * 
     * @type {BriefType}
     * @memberof UpdateBriefRequest
     */
    type: BriefType;
    /**
     * 
     * @type {Array<Criterion>}
     * @memberof UpdateBriefRequest
     */
    refinementCriteria?: Array<Criterion>;
    /**
     * 
     * @type {number}
     * @memberof UpdateBriefRequest
     */
    numberOfFreelancersNeeded?: number;
}

/**
 * Check if a given object implements the UpdateBriefRequest interface.
 */
export function instanceOfUpdateBriefRequest(value: object): value is UpdateBriefRequest {
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('duration' in value) || value['duration'] === undefined) return false;
    if (!('finance' in value) || value['finance'] === undefined) return false;
    if (!('workConditions' in value) || value['workConditions'] === undefined) return false;
    if (!('startDate' in value) || value['startDate'] === undefined) return false;
    if (!('profile' in value) || value['profile'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function UpdateBriefRequestFromJSON(json: any): UpdateBriefRequest {
    return UpdateBriefRequestFromJSONTyped(json, false);
}

export function UpdateBriefRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateBriefRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'title': ProjectTitleFromJSON(json['title']),
        'description': ProjectDescriptionFromJSON(json['description']),
        'duration': DurationFromJSON(json['duration']),
        'finance': FinanceFromJSON(json['finance']),
        'workConditions': WorkConditionsFromJSON(json['workConditions']),
        'startDate': StartDateFromJSON(json['startDate']),
        'profile': ProfileFromJSON(json['profile']),
        'type': BriefTypeFromJSON(json['type']),
        'refinementCriteria': json['refinementCriteria'] == null ? undefined : ((json['refinementCriteria'] as Array<any>).map(CriterionFromJSON)),
        'numberOfFreelancersNeeded': json['numberOfFreelancersNeeded'] == null ? undefined : json['numberOfFreelancersNeeded'],
    };
}

export function UpdateBriefRequestToJSON(value?: UpdateBriefRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'title': ProjectTitleToJSON(value['title']),
        'description': ProjectDescriptionToJSON(value['description']),
        'duration': DurationToJSON(value['duration']),
        'finance': FinanceToJSON(value['finance']),
        'workConditions': WorkConditionsToJSON(value['workConditions']),
        'startDate': StartDateToJSON(value['startDate']),
        'profile': ProfileToJSON(value['profile']),
        'type': BriefTypeToJSON(value['type']),
        'refinementCriteria': value['refinementCriteria'] == null ? undefined : ((value['refinementCriteria'] as Array<any>).map((v) => CriterionToJSON(v))),
        'numberOfFreelancersNeeded': value['numberOfFreelancersNeeded'],
    };
}

